import { Component, Injector, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { PageBase } from 'src/app/shared/library/page.base';
import { KindBoard } from 'src/utils/enums';
import { TaskItem } from '../../taskcommon/taskcommon.class';
import { TaskContract } from './taskcontract';
import { TaskContractService } from './taskcontract.service';

@Component({
    selector: 'cp-taskcontract',
    templateUrl: './taskcontract.component.html',
    styleUrls: ['./taskcontract.component.css'],
    standalone: false
})
export class TaskContractComponent extends PageBase implements OnInit, OnChanges {

  @Input() taskitem: TaskItem;
  TaskContract: TaskContract = new TaskContract();
  isHideLoading: boolean;
  labelContratadoLiberado: string = '';
  labelStartLegend = '';
  labelEndLegend = '';
  valorContratadoouMedido: number = 0;
  valorStart: number = 0;
  valorEnd: number = 0;
  percentageChartGauge: number = 0;

  constructor(private taskContractService: TaskContractService,
              public ObjInjector: Injector)
  {
    super(ObjInjector);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.taskitem = new TaskItem();
    this.TaskContract.amountPaid = 0;
    this.TaskContract.amountReleased = 0;
    this.TaskContract.balanceToPay = 0;
    this.TaskContract.contractedAmount = 0;
    this.TaskContract.currencyCode = '';
    this.TaskContract.measuredValue = 0;
    this.TaskContract.percentageMeasuredUnderContracted = 0;
    this.TaskContract.percentagePaidUnderReleased = 0;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.taskitem){
      this.isHideLoading = false;
      this.load();
    }
  }

  private async load() {
    if(this.contextApplication.currentVision == KindBoard.Tarefa.valueOf()) {
      this.TaskContract = await this.taskContractService.GetInfoTask(this.taskitem);
      this.labelContratadoLiberado = (<string>this.literalsCp?.strContracts).toUpperCase();
      this.labelStartLegend = this.literalsCp?.strMedido;
      this.labelEndLegend = this.literalsCp?.strContratado;
      this.valorContratadoouMedido = this.TaskContract.contractedAmount;
      this.valorStart = this.TaskContract.measuredValue;
      this.valorEnd = this.TaskContract.contractedAmount;
      this.percentageChartGauge = this.TaskContract.percentageMeasuredUnderContracted;
    }
    else {
      this.TaskContract = await this.taskContractService.GetInfoTaskByInput(this.taskitem);
      this.labelContratadoLiberado = (<string>this.literalsCp?.strMedicoes).toUpperCase();
      this.labelStartLegend = this.literalsCp?.strLiberado;
      this.labelEndLegend = this.literalsCp?.strMedido;
      this.valorContratadoouMedido = this.TaskContract.measuredValue;
      this.valorStart = this.TaskContract.amountReleased;
      this.valorEnd = this.TaskContract.measuredValue;
      this.percentageChartGauge = this.TaskContract.percentageReleasedUnderMeasured;
    }
    this.isHideLoading = true;
  }

  onReceiveLiterals() {}

}
